import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ItineraryService } from 'src/app/business-service/quote/itinerary.service';
import { GlobalService } from 'src/app/modules/shared/services/global/global.service';
import { ModalsService } from 'src/app/modules/shared/services/modals/modals.service';
import { ComponentReloadService } from 'src/app/modules/shared/services/reload/component-reload.service';
import { ResponseNotificationService } from 'src/app/modules/shared/services/response-notification/response-notification.service';
import { InputValidationsService } from 'src/app/modules/shared/services/validations/input-validations.service';

@Component({
  selector: 'app-cost-and-price',
  templateUrl: './cost-and-price.component.html',
  styleUrls: ['./cost-and-price.component.scss'],
})
export class CostAndPriceComponent implements OnInit {

  @Input() leadId: any;
  @Input() itineraryId: any;
  @Output() viewChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() viewChangeToTab: EventEmitter<string> = new EventEmitter<string>();

  @Output() storeFormData: EventEmitter<any> = new EventEmitter();

  @Output() updateQuote: EventEmitter<void> = new EventEmitter();

  @Input() storedFormData: any;
  @Input() editInventory: boolean = false;
  @Input() editQuote: boolean = false;

  @Input() itineraryDetails: any;
  @Input() accommodation: any = {};
  @Input() flightsData: any;
  @Input() trainsData: any;
  @Input() busesData: any;
  @Input() carsData: any;
  @Input() ferryData: any;
  @Input() cruiseData: any;

  @Input() serviceBasedSections: any;

  @Input() dmcPackageId: any;
  @Input() dmcHotelPricingData: any;

  showAirFares: boolean = false;
  showAddMorePackageBtn: boolean = true;

  noOfAdults: number = 0;
  noOfChildren: number = 0;
  noOfInfants: number = 0;
  childrenBelowTwo: any = 0;
  childrenAboveTwo: any = 0;

  noOfAdutlsDropdown: any = [];
  noOfChildrenDropdown: any = [];

  totalItineraryAmount: any = 0;
  landPackageForm!: FormGroup;

  constructor(
    private _fb: FormBuilder,
    private _itineraryService: ItineraryService,
    private _responseNotificationService: ResponseNotificationService,
    private _globalService: GlobalService,
    private _reloadService: ComponentReloadService,
    private _modalService: ModalsService
  ) { }

  ngOnInit() {
    // Initilization of the variables
    this.noOfAdults = 0;
    this.noOfChildren = 0;
    this.noOfInfants = 0;
    this.childrenAboveTwo = 0;
    this.childrenBelowTwo = 0;
    this.noOfAdutlsDropdown = [];
    this.noOfChildrenDropdown = [];
    this.totalItineraryAmount = 0;

    if (this.itineraryDetails) {
      this.updateAllItineraryData();
    }

    this.landPackageForm = this._fb.group({
      landPackages: this._fb.array([this.createLandPackageGroup()]),
      airfarePerAdult: [""],
      airfarePerChild: [""],
      airfarePerInfant: [""],
      totalAirFare: [{ value: "", disabled: true }],
      showTotalCost: [false],
      showLandPackages: [true],
      estimatedTotalCost: [{ value: '', disabled: true }],
      sectionNote: ['']
    });

    this.landPackageForm.valueChanges.subscribe(() => {
      this.landPackageForm.markAsTouched();
    })

    // Update validations
    if (this.serviceBasedSections.showTourPackage || this.serviceBasedSections.showRouteCraft) {
      this.addRequiredFormValidations()
      this.landPackageForm.markAsPristine();
      this.landPackageForm.markAsTouched();
    }


    if (this.childrenAboveTwo === 0) {
      this.landPackageForm.get('airfarePerChild')?.setValue("");
      this.landPackageForm.get('airfarePerChild')?.disable();
      this.landPackageForm.markAsUntouched();
      this.landPackageForm.markAsPristine();
    }
    if (this.childrenBelowTwo === 0) {
      this.landPackageForm.get('airfarePerInfant')?.setValue("");
      this.landPackageForm.get('airfarePerInfant')?.disable();
      this.landPackageForm.markAsUntouched();
      this.landPackageForm.markAsPristine();
    }

    // Prefilling hotel if only one exits
    if (this.accommodation) {
      // if in formatted accommodation for each location there is only one hotel then give an if condition
      if (this.checkOneHotelInLocation()) {
        this.landPackages.at(0).get('hotelsIncluded')?.setValue(this.accommodation.data);
        this.landPackageForm.markAsUntouched();
        this.landPackageForm.markAsPristine();
      }
    }

    this.landPackageForm.get('airfarePerAdult')?.valueChanges.subscribe((value) => {
      this.calculateTotalCost();
    });
    this.landPackageForm.get('airfarePerChild')?.valueChanges.subscribe((value) => {
      this.calculateTotalCost();
    });
    this.landPackageForm.get('airfarePerInfant')?.valueChanges.subscribe((value) => {
      this.calculateTotalCost();
    });


    if (this.storedFormData) {
      this.patchCostAndPricingValues(this.storedFormData);
      if (this.storedFormData.dataInvalid) {
        this.landPackageForm.markAllAsTouched();
        this.landPackageForm.markAsDirty();
      }
    } else {
      // If quote is created based on dmc package
      if (this.dmcPackageId && this.dmcHotelPricingData) {
        this.createPackagesForDmcPricingData(this.dmcHotelPricingData.packages, this.dmcHotelPricingData.currency);
      }
    }

    // Creating grid of cost of transportion

    if (this.flightsData && this.flightsData?.data) {
      for (let data of this.flightsData.data) {
        this.totalItineraryAmount = this.totalItineraryAmount + data.totalCost;
      }
    }
    if (this.trainsData && this.trainsData?.data) {
      for (let data of this.trainsData.data) {
        this.totalItineraryAmount = this.totalItineraryAmount + data.totalCost;
      }
    }
    if (this.busesData && this.busesData?.data) {
      for (let data of this.busesData.data) {
        this.totalItineraryAmount = this.totalItineraryAmount + data.totalCost;
      }
    }
    if (this.carsData && this.carsData?.data) {
      for (let data of this.carsData.data) {
        this.totalItineraryAmount = this.totalItineraryAmount + data.totalCost;
      }
    }
    if (this.ferryData && this.ferryData?.data) {
      for (let data of this.ferryData.data) {
        this.totalItineraryAmount = this.totalItineraryAmount + data.totalCost;
      }
    }
    if (this.cruiseData && this.cruiseData?.data) {
      for (let data of this.cruiseData.data) {
        this.totalItineraryAmount = this.totalItineraryAmount + data.totalCost;
      }
    }

    if (!this.serviceBasedSections.showRouteCraft) {
      if (this.storedFormData?.totalQuoteCost || this.totalItineraryAmount) {
        if (this.totalItineraryAmount !== this.storedFormData?.totalQuoteCost) {
          this.landPackageForm.markAsTouched();
          this.landPackageForm.markAsDirty();
        }
      }
    }

  }

  checkOneHotelInLocation(): boolean {
    let accommodationData = this.accommodation?.data || [];
    if (!accommodationData?.length) {
      return false;
    }
    for (let destination of accommodationData) {
      for (let location of destination.locations) {
        if (location.hotels.length !== 1) {
          return false;
        }
      }
    }
    return true;
  }

  get landPackages() {
    return this.landPackageForm.get('landPackages') as FormArray;
  }

  createPackagesForDmcPricingData(dmcPackages: any[], dmcCurrency: any) {
    this.landPackages.clear();

    dmcPackages.forEach((pkg: any) => {
      let group = this.createLandPackageGroup();
      let occupancy = pkg.occupancyPricings[0];

      let hotelInPackage: any[] = [];

      pkg.locations.forEach((loc: any) => {
        let tempHotel = {
          destination: loc.locationName,
          locations: [{
            locationName: loc.locationName,
            hotels: [
              {
                hotelName: loc.hotelName,
                roomCategory: pkg.hotelCategory,
                mealPlan: loc.mealPlan || [],
                noOfNights: loc.nights
              }
            ]
          }
          ]
        }
        hotelInPackage.push(tempHotel);
      });

      group.patchValue({
        hotelsIncluded: hotelInPackage,
        dmcAdultCost: `${occupancy.occupancy[occupancy.selectedOccupancy] || "NA"} ${dmcCurrency}`,
        dmcChildWithBedCost: `${occupancy.childWithBed || "NA"} ${dmcCurrency}`,
        dmchildWithoutBedCost: `${occupancy.extraChildWithoutBed || "NA"} ${dmcCurrency}`
      });

      group.get('hotelsIncluded')?.disable();

      this.landPackages.push(group);
    });
  }

  addLandPackage() {
    this.landPackages.push(this.createLandPackageGroup());
  }

  removeLandPackage(index: number) {
    this.landPackages.removeAt(index);
    this.landPackageForm.markAsDirty();
    this.landPackageForm.markAsTouched();
  }

  createLandPackageGroup(): FormGroup {
    const group = this._fb.group({
      hotelsIncluded: [[]],
      perAdult: [{ inputValue: '', dropdownValue: this.noOfAdults }],
      perChildWithBed: [{ inputValue: '', dropdownValue: this.childrenAboveTwo }],
      perChildWithoutBed: [{ inputValue: '', dropdownValue: this.childrenBelowTwo }],
      dmcAdultCost: [''],
      dmcChildWithBedCost: [''],
      dmchildWithoutBedCost: [''],
      packageCost: [{ value: 0, disabled: true }],
      addPriceDetailsBreakdown: [false],
      showPriceDetail: [{ value: false, disabled: true }],
      priceDetail: this._fb.array([])
    }, {
      validators: [this.priceDetailsTotalCostValidator.bind(this)]
    });

    if (this.noOfChildren) {
      this.addNoOfChildrenToggleSubscription(group);
    }

    if (this.noOfChildren === 0) {
      group.get('perChildWithBed')?.setValue({ inputValue: '', dropdownValue: null });
      group.get('perChildWithoutBed')?.setValue({ inputValue: '', dropdownValue: null });

      group.get('perChildWithBed')?.updateValueAndValidity();
      group.get('perChildWithoutBed')?.updateValueAndValidity();

      group.get('perChildWithBed')?.disable();
      group.get('perChildWithoutBed')?.disable();
    }

    group.get('perAdult')?.valueChanges.subscribe((value) => {
      this.addCalculationSubscription(group);
    });
    group.get('perChildWithBed')?.valueChanges.subscribe((value) => {
      this.addCalculationSubscription(group);
    });
    group.get('perChildWithoutBed')?.valueChanges.subscribe((value) => {
      this.addCalculationSubscription(group);
    });

    // Subscribe to priceDetail changes to enable/disable showPriceDetail
    const priceDetailArray = group.get('priceDetail') as FormArray;
    priceDetailArray.valueChanges.subscribe(() => {
      const showPriceDetailCtrl = group.get('showPriceDetail');
      if (priceDetailArray.length === 0) {
        showPriceDetailCtrl?.disable({ emitEvent: false });
      } else {
        showPriceDetailCtrl?.enable({ emitEvent: false });
      }
      // Trigger validator update when price details change
      group.updateValueAndValidity({ onlySelf: true, emitEvent: false });
    });

    group.get('addPriceDetailsBreakdown')?.valueChanges.subscribe(async (value) => {
      let priceDetailsArray = group.get('priceDetail') as FormArray;
      if (value) {
        if (priceDetailsArray.length === 0) {
          let pricingGroup = this.createPriceDetailsFormGroup(group);
          if(group.get('perAdult')?.value?.inputValue){
            pricingGroup.patchValue({
              type: 'Land Package',
              costPerAdult: group.get('perAdult')?.value?.inputValue,
              costPerChildWithBed: group.get('perChildWithBed')?.value?.inputValue,
              costPerChildWithoutBed: group.get('perChildWithoutBed')?.value?.inputValue,
              totalCost: group.get('packageCost')?.value
            }, { emitEvent: false })
          }
          priceDetailsArray.push(pricingGroup);
        }
      } else {
        // check if any value is entered in price details
        let hasValue = priceDetailsArray.controls.some(ctrl => {
          const val = ctrl.value;
          return val.type || val.costPerAdult || val.costPerChildWithBed || val.costPerChildWithoutBed;
        });
        if (hasValue) {
          const confirm = await this._globalService.confirmActionPopup(
            "This will clear all price details. Do you want to continue?",
            "Confirm",
            "Yes"
          );
          if (confirm) {
            priceDetailsArray.clear();
          } else {
            group.get('addPriceDetailsBreakdown')?.setValue(true, { emitEvent: false });
          }
        } else {
          priceDetailsArray.clear();
        }
      }
    });

    if (this.accommodation?.data?.length > 0 && this.serviceBasedSections.showRouteCraft && this.serviceBasedSections.showHotels) {
      group.get('hotelsIncluded')?.setValidators([this.requireHotelPerLocationValidator.bind(this)]);
      group.get('hotelsIncluded')?.updateValueAndValidity();
    }

    return group;
  }

  // Custom validator: sum of all totalCost in priceDetail must equal packageCost
  priceDetailsTotalCostValidator(group: AbstractControl) {
    const priceDetailArray = group.get('priceDetail') as FormArray;
    const packageCostCtrl = group.get('packageCost');
    if (!priceDetailArray || !packageCostCtrl) return null;

    // Only validate if price details breakdown is enabled and there are items
    const addBreakdown = group.get('addPriceDetailsBreakdown')?.value;
    if (!addBreakdown || priceDetailArray.length === 0) return null;

    const sum = priceDetailArray.controls.reduce((acc, ctrl) => {
      const val = ctrl.get('totalCost')?.value;
      return acc + (Number(val) || 0);
    }, 0);

    const packageCost = Number(packageCostCtrl.value);

    // Only show error if both are numbers and not equal
    if (!isNaN(sum) && !isNaN(packageCost) && sum !== packageCost) {
      return { priceDetailsTotalCostMismatch: true };
    }
    return null;
  }

  checkPriceDetailsTotalCostMismatch(group: AbstractControl): boolean {
    return group.hasError('priceDetailsTotalCostMismatch') && (group.touched || group.dirty);
  }

  createPriceDetailsFormGroup(parentFormGroup: any): FormGroup {
    const group = this._fb.group({
      type: ['', [Validators.required]],
      costPerAdult: ['', [Validators.required]],
      costPerChildWithBed: [''],
      costPerChildWithoutBed: [''],
      totalCost: ['']
    });

    if (this.noOfChildren + this.noOfInfants === 0) {
      group.get('costPerChildWithBed')?.disable();
      group.get('costPerChildWithoutBed')?.disable();
    }

    group.get('costPerAdult')?.valueChanges.subscribe((value) => {
      this.calculatePriceDetailTotalCost(parentFormGroup, group);
    })
    group.get('costPerChildWithBed')?.valueChanges.subscribe((value) => {
      this.calculatePriceDetailTotalCost(parentFormGroup, group);
    })
    group.get('costPerChildWithoutBed')?.valueChanges.subscribe((value) => {
      this.calculatePriceDetailTotalCost(parentFormGroup, group);
    })

    return group;
  }

  calculatePriceDetailTotalCost(parentFormGroup: any, detailGroup: any) {
    let totalCost = 0;
    totalCost += detailGroup.get('costPerAdult')?.value * parentFormGroup.get('perAdult')?.value?.dropdownValue;
    totalCost += detailGroup.get('costPerChildWithBed')?.value * parentFormGroup.get('perChildWithBed')?.value?.dropdownValue;
    totalCost += detailGroup.get('costPerChildWithoutBed')?.value * parentFormGroup.get('perChildWithoutBed')?.value?.dropdownValue;
    detailGroup.get('totalCost')?.setValue(totalCost);

    this.updateTotalPerCostInPackage(parentFormGroup, detailGroup)
  }

  updateTotalPerCostInPackage(parentFormGroup: any, detailGroup: any){
    let sumOfAdultCost = 0;
    let sumOfChildWithBedCost = 0;
    let sumOfChildWithoutBedCost = 0;
    const priceDetailsArray = parentFormGroup.get('priceDetail') as FormArray;
    priceDetailsArray.controls.forEach((ctrl: any) => {
      sumOfAdultCost += +ctrl.get('costPerAdult')?.value || 0;
      sumOfChildWithBedCost += +ctrl.get('costPerChildWithBed')?.value || 0;
      sumOfChildWithoutBedCost += +ctrl.get('costPerChildWithoutBed')?.value || 0;
    });

    let currentAdultCost = parentFormGroup.get('perAdult')?.value;
    let currentChildWithBedCost = parentFormGroup.get('perChildWithBed')?.value;
    let currentChildWithoutBedCost = parentFormGroup.get('perChildWithoutBed')?.value;

    parentFormGroup.get('perAdult')?.setValue({ inputValue: sumOfAdultCost, dropdownValue: currentAdultCost?.dropdownValue });
    parentFormGroup.get('perChildWithBed')?.setValue({ inputValue: sumOfChildWithBedCost, dropdownValue: currentChildWithBedCost?.dropdownValue });
    parentFormGroup.get('perChildWithoutBed')?.setValue({ inputValue: sumOfChildWithoutBedCost, dropdownValue: currentChildWithoutBedCost?.dropdownValue });
  }


  getPriceDetailsArray(index: number): FormArray {
    return this.landPackages.at(index).get('priceDetail') as FormArray;
  }

  addPriceDetail(index: number) {
    this.getPriceDetailsArray(index).push(this.createPriceDetailsFormGroup(this.landPackages.at(index)));
    this.landPackageForm.markAsDirty();
    this.landPackageForm.markAsTouched();
  }

  removePriceDetail(packageIndex: number, detailIndex: number) {
    this.getPriceDetailsArray(packageIndex).removeAt(detailIndex);
    let parentGroup = this.landPackages.at(packageIndex);
    let detailsArray = parentGroup.get('priceDetail') as FormArray;
    detailsArray.controls.forEach((detailGroup: any) => {
      this.calculatePriceDetailTotalCost(parentGroup, detailGroup);
    });
    this.landPackageForm.markAsDirty();
    this.landPackageForm.markAsTouched();
  }

  //custom validator to check if at least one hotel is selected per location
  requireHotelPerLocationValidator(control: AbstractControl) {
    const selectedHotels = control.value || [];

    const selectedLocations = selectedHotels
      .flatMap((dest: any) =>
        dest.locations.map((loc: any) => loc.locationName)
      );

    const requiredLocations = this.accommodation?.data?.flatMap(
      (dest: any) =>
        dest.locations.map((loc: any) => loc.locationName)
    ) || [];

    const allSelected = requiredLocations.every(
      (loc: string) => selectedLocations.includes(loc)
    );

    return allSelected ? null : { missingHotels: true };
  }



  addCalculationSubscription(group: FormGroup) {
    let totalCost = 0;
    totalCost += group.get('perAdult')?.value?.dropdownValue * group.get('perAdult')?.value?.inputValue;
    totalCost += group.get('perChildWithBed')?.value?.dropdownValue * group.get('perChildWithBed')?.value?.inputValue;
    totalCost += group.get('perChildWithoutBed')?.value?.dropdownValue * group.get('perChildWithoutBed')?.value?.inputValue;

    group.get('packageCost')?.setValue(totalCost);
    group.get('packageCost')?.updateValueAndValidity();

    // // update totalCost in price details if exists
    // const priceDetailsArray = group.get('priceDetail') as FormArray;
    // priceDetailsArray.controls.forEach((detailGroup: any) => {
    //   this.calculatePriceDetailTotalCost(group, detailGroup);
    // });
  }

  updateAllItineraryData() {
    this.noOfAdults = this.itineraryDetails.totalAdults;
    this.noOfChildren = this.itineraryDetails.totalChildrens;
    this.noOfInfants = this.itineraryDetails.totalInfants;

    this.noOfAdutlsDropdown = [{ value: this.noOfAdults, name: `${this.noOfAdults} Adults` }];
    for (let i = 0; i <= this.noOfChildren + this.noOfInfants; i++) {
      let item = {
        value: i,
        name: `${i} Children`
      }
      this.noOfChildrenDropdown.push(item);
    }

    this.childrenAboveTwo = this.noOfChildren;
    this.childrenBelowTwo = this.noOfInfants;


    if (this.serviceBasedSections.showRouteCraft && !this.serviceBasedSections.showHotels) {
      this.showAddMorePackageBtn = false;
    }

    // Hotels
    // Generating list of hotels to multi select in hotels included field
    if (this.accommodation && this.accommodation?.data?.length) {
      for (let data of this.accommodation.data) {
        for (let location of data.locations) {
          for (let hotel of location.hotels) {
            this.totalItineraryAmount = this.totalItineraryAmount + hotel.totalCostOfAccommodation;
          }
        }
      }
    }

    // Transportion

    // Showing airfare in flights exists
    if (this.serviceBasedSections.showTransportation && this.flightsData && this.flightsData?.data?.length) {
      this.showAirFares = true;
    }

    // DMC package
    if (this.dmcPackageId && this.dmcHotelPricingData) {
      let packageHotels: any[] = [];
      this.dmcHotelPricingData.packages.forEach((pack: any, packageIndex: number) => {
        pack.locations.forEach((loc: any, locIndex: number) => {
          let hotel = {
            location: loc.locationName,
            hotelName: loc.hotelName,
            hotelType: pack.hotelCategory,
            roomCategory: ''
          }
          packageHotels.push(hotel);
        });
      });
      if (!this.accommodation) {
        this.accommodation = {};
      }
      this.accommodation.data = this.groupByLocation(packageHotels, 'location');
    }
  }

  addNoOfChildrenToggleSubscription(group: any) {
    // Subscribe to 'perChildWithBed' value changes
    group.get('perChildWithBed')?.valueChanges.subscribe((value: any) => {
      const currentWithoutBedValue = group.get('perChildWithoutBed')?.value;
      const newWithoutBedValue = {
        inputValue: currentWithoutBedValue.inputValue,
        dropdownValue: (this.noOfChildren + this.noOfInfants) - value?.dropdownValue
      };

      // Update 'perChildWithoutBed' only if the values are different
      if (JSON.stringify(currentWithoutBedValue) !== JSON.stringify(newWithoutBedValue)) {
        group.get('perChildWithoutBed')?.setValue(newWithoutBedValue, { emitEvent: false });
      }
    });

    // Subscribe to 'perChildWithoutBed' value changes
    group.get('perChildWithoutBed')?.valueChanges.subscribe((value: any) => {
      const currentWithBedValue = group.get('perChildWithBed')?.value;
      const newWithBedValue = {
        inputValue: currentWithBedValue.inputValue,
        dropdownValue: (this.noOfChildren + this.noOfInfants) - value?.dropdownValue
      };

      // Update 'perChildWithBed' only if the values are different
      if (JSON.stringify(currentWithBedValue) !== JSON.stringify(newWithBedValue)) {
        group.get('perChildWithBed')?.setValue(newWithBedValue, { emitEvent: false });
      }
    });


  }

  checkInvalidControl(group: any, formControlName: string): boolean {
    const control = group.get(formControlName)
    return control?.invalid && (control?.touched || control?.dirty);
  }

  patchCostAndPricingValues(formData: any) {
    // First clear existing land packages and repopulate
    const landPackagesArray = this.landPackageForm.get('landPackages') as FormArray;
    landPackagesArray.clear();

    // Patch each land package from formData
    formData.landPackages.forEach((packageData: any) => {
      const landPackageGroup = this.createLandPackageGroup();

      landPackageGroup.patchValue({
        hotelsIncluded: packageData.hotelsIncluded,
        dmcAdultCost: packageData.dmcAdultCost,
        dmcChildWithBedCost: packageData.dmcChildWithBedCost,
        dmchildWithoutBedCost: packageData.dmchildWithoutBedCost,
        perAdult: { inputValue: packageData.costPerAdult, dropdownValue: this.noOfAdults },
        perChildWithBed: { inputValue: packageData.costPerChildWithBed, dropdownValue: packageData.noOfChildrenWithBed > this.noOfChildren ? this.childrenAboveTwo : packageData.noOfChildrenWithBed },
        perChildWithoutBed: { inputValue: packageData.costPerChildWithoutBed, dropdownValue: packageData.noOfChildrenWithoutBed > this.noOfChildren ? this.childrenBelowTwo : packageData.noOfChildrenWithoutBed },
        showPriceDetail: packageData.showPriceDetail,
        addPriceDetailsBreakdown: (packageData.priceDetail && packageData.priceDetail.length > 0) ? true : false
      });
      // Patch price details if available
      if (packageData.priceDetail && packageData.priceDetail.length > 0) {
        const priceDetailsArray = landPackageGroup.get('priceDetail') as FormArray;
        priceDetailsArray.clear();
        packageData.priceDetail.forEach((detail: any) => {
          const detailGroup = this.createPriceDetailsFormGroup(landPackageGroup);
          detailGroup.patchValue(detail, { emitEvent: false });
          priceDetailsArray.push(detailGroup);
        });
      }

      if(this.dmcPackageId){
        landPackageGroup.get("hotelsIncluded")?.disable();
      }

      if (this.noOfChildren === 0) {
        landPackageGroup.patchValue({
          perChildWithBed: { inputValue: '', dropdownValue: null },
          perChildWithoutBed: { inputValue: '', dropdownValue: null },
        });
      }

      landPackagesArray.push(landPackageGroup);
    });

    // Patch other form data
    this.landPackageForm.patchValue({
      airfarePerAdult: formData.airfarePerAdult,
      airfarePerChild: formData.airfarePerChild,
      airfarePerInfant: formData.airfarePerInfant,
      showTotalCost: formData.showTotalCost,
      showLandPackages: formData.showLandPackages,
      estimatedTotalCost: formData.totalAmount,
      sectionNote: formData.note
    });
  }


  addRequiredFormValidations() {
    if (this.showAirFares) {
      this.landPackageForm.get('airfarePerAdult')?.setValidators([Validators.required]);
      if (this.noOfChildren) {
        this.landPackageForm.get('airfarePerChild')?.setValidators([Validators.required]);
        this.landPackageForm.get('airfarePerInfant')?.setValidators([Validators.required]);
      }

      this.landPackageForm.get('airfarePerAdult')?.updateValueAndValidity();
      this.landPackageForm.get('airfarePerChild')?.updateValueAndValidity();
      this.landPackageForm.get('airfarePerInfant')?.updateValueAndValidity();
    }
  }

  calculateTotalCost() {
    let totalCost = 0;
    totalCost += this.landPackageForm.get('airfarePerAdult')?.value * this.noOfAdults;
    totalCost += this.landPackageForm.get('airfarePerChild')?.value * this.childrenAboveTwo;
    totalCost += this.landPackageForm.get('airfarePerInfant')?.value * this.childrenBelowTwo;

    this.landPackageForm.get('totalAirFare')?.setValue(totalCost);
  }

  // funtion to change no of people and cost when price breakdown is updated
  getNoOfAdultsInPackage(index: number): number {
    return this.landPackages.at(index).get('perAdult')?.value?.dropdownValue || 0;
  }
  getNoOfChildrenWithBedInPackage(index: number): number {    
    return this.landPackages.at(index).get('perChildWithBed')?.value?.dropdownValue || 0;
  }
  getNoOfChildrenWithoutBedInPackage(index: number): number {
    return this.landPackages.at(index).get('perChildWithoutBed')?.value?.dropdownValue || 0;
  }
  setNoOfChildrenWithBedInPackage(index: number, event: any) {
    const value = event.target.value;
    const currentValue = this.landPackages.at(index).get('perChildWithBed')?.value;
    this.landPackages.at(index).get('perChildWithBed')?.setValue({ inputValue: currentValue.inputValue, dropdownValue: value });

    let parentGroup = this.landPackages.at(index);
    let detailsArray = parentGroup.get('priceDetail') as FormArray;
    detailsArray.controls.forEach((detailGroup: any) => {
      this.calculatePriceDetailTotalCost(parentGroup, detailGroup);
    });

    this.landPackageForm.markAsTouched();
    this.landPackageForm.markAsDirty();
  }
  setNoOfChildrenWithoutBedInPackage(index: number, event: any) {
    const value = event.target.value;
    const currentValue = this.landPackages.at(index).get('perChildWithoutBed')?.value;
    this.landPackages.at(index).get('perChildWithoutBed')?.setValue({ inputValue: currentValue.inputValue, dropdownValue: value });

    let parentGroup = this.landPackages.at(index);
    let detailsArray = parentGroup.get('priceDetail') as FormArray;
    detailsArray.controls.forEach((detailGroup: any) => {
      this.calculatePriceDetailTotalCost(parentGroup, detailGroup);
    });

    this.landPackageForm.markAsTouched();
    this.landPackageForm.markAsDirty();
  }

  getTotalCostPerAdultInPackage(index: number): number {
    return this.landPackages.at(index).get('perAdult')?.value?.inputValue || 0;
  }
  getTotalCostPerChildWithBedInPackage(index: number): number {
    return this.landPackages.at(index).get('perChildWithBed')?.value?.inputValue || 0;
  }
  getTotalCostPerChildWithoutBedInPackage(index: number): number {
    return this.landPackages.at(index).get('perChildWithoutBed')?.value?.inputValue || 0;
  }
  getPackageCost(index: number): number {
    return this.landPackages.at(index).get('packageCost')?.value || 0;
  }

  async onSubmit(): Promise<boolean> {
    if (!this.landPackageForm.valid) {
      this.landPackageForm.markAllAsTouched();
      this._globalService.scrollToFirstInvalidControl();
      this._globalService.customAlert("Fill all required fields to save", "Invalid Form");
      return false;
    }

    const formData = await this.serializeFormData(this.landPackageForm.getRawValue());

    if (this.editQuote) {
      this.finalizeFormSubmission(formData);
      this.updateQuote.emit();
      return true;
    }

    return this.addNewCostAndPricing(formData);
  }

  private async addNewCostAndPricing(formData: any): Promise<boolean> {
    try {
      const data = await this._itineraryService.addCostAndPricing(formData).toPromise();
      this._responseNotificationService.showMessage("Cost And Pricing Added!");
      this.finalizeFormSubmission(data);
      this._reloadService.triggerQuotesReload();
      return true;
    } catch (error) {
      console.error("Error adding cost and pricing", error);
      return false;
    }
  }

  private finalizeFormSubmission(data: any): void {
    this.landPackageForm.markAsPristine();
    data.dataSaved = true;
    this.storeFormData.emit(data);
  }


  private async serializeFormData(formData: any) {
    const serializedData = {
      itineraryId: this.itineraryId,
      leadId: this.leadId,
      landPackages: formData.landPackages.map((landPackage: any) => ({
        hotelsIncluded: landPackage.hotelsIncluded,
        costPerAdult: landPackage.perAdult?.inputValue,
        costPerChildWithoutBed: landPackage.perChildWithoutBed?.inputValue,
        costPerChildWithBed: landPackage.perChildWithBed?.inputValue,
        packageCost: landPackage.packageCost,
        noOfAdults: landPackage.perAdult?.dropdownValue,
        noOfChildrenWithBed: landPackage.perChildWithBed?.dropdownValue,
        noOfChildrenWithoutBed: landPackage.perChildWithoutBed?.dropdownValue,
        packageIncludingAirfare: landPackage.packageCost + formData.totalAirFare,
        // DMC costs
        dmcAdultCost: landPackage.dmcAdultCost,
        dmcChildWithBedCost: landPackage.dmcChildWithBedCost,
        dmchildWithoutBedCost: landPackage.dmchildWithoutBedCost,
        // detailed price breakdown
        priceDetail: landPackage.priceDetail,
        showPriceDetail: landPackage.showPriceDetail
      })),
      noOfAdults: this.noOfAdults,
      noOfChildren: this.childrenAboveTwo,
      noOfInfants: this.childrenBelowTwo,
      airfarePerAdult: formData.airfarePerAdult,
      airfarePerChild: formData.airfarePerChild,
      airfarePerInfant: formData.airfarePerInfant,
      totalAirfare: formData.totalAirFare,
      showTotalCost: formData.showTotalCost,
      showLandPackages: formData.showLandPackages,
      totalQuoteCost: this.totalItineraryAmount,
      note: formData.sectionNote,
      organizationId: this.storedFormData?.organizationId,
      id: this.storedFormData ? this.storedFormData.id : null,
      createdBy: this.storedFormData ? this.storedFormData.createdBy : null,
      ...(this.storedFormData && { createDate: this.storedFormData.createDate })
    }

    return serializedData;
  }

  // Grouping accommodation and transportation data

  private groupByLocation(data: any[], locationKey: string) {
    return data.reduce((acc, item) => {
      const location = item[locationKey];
      if (!acc[location]) {
        acc[location] = [];
      }
      acc[location].push(item);
      return acc;
    }, {});
  }

  // Openig image in a popup window
  openImage(url: any) {
    this._modalService.openImageModal(url);
  }

  async resetForm() {
    if (await this._globalService.confirmActionPopup("Confirm to reset data", "Confirm", "Confirm")) {
      this.ngOnInit();
    }
  }

  getHotelsData() {
    if (this.accommodation && this.accommodation.data) {
      return JSON.parse(JSON.stringify(this.accommodation.data));
    } else {
      return [];
    }
  }

  goPrevious() {
    this.viewChange.emit(true);
  }

  goNext() {
    this.viewChange.emit(false);
  }

  async saveAndNext() {
    if (await this.onSubmit()) {
      this.goNext()
    }
  }

  formDataModified(): boolean {
    return (this.landPackageForm.dirty || this.landPackageForm.invalid) && this.landPackageForm.touched;
  }

  goToView(view: string) {
    this.viewChangeToTab.emit(view);
  }
}
